module.exports = __webpack_public_path__ + "img/xwzx.b0306ccc.png";